/**
 * 获取文件base64
 */
export const getBase64 = (file: File | Blob): Promise<any> => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader()
		reader.readAsDataURL(file)
		reader.onload = () => resolve(reader.result)
		reader.onerror = error => reject(error)
	})
}

/**
 * 获取Url参数（包含hash后的参数）
 * @param {String} originUrl 非必传，未传时默认为当前链接
 * @return {Object} 全部链接参数组成的对象
 */
export function getUrlParams(originUrl?: string) {
	const url = originUrl ? originUrl : document.location.toString()
	const arrObj = url.split('?')
	const params = Object.create(null)
	if (arrObj.length > 1) {
		// arrObj数组的元素组成：页面链接、hash前的参数、hash后的参数
		arrObj.splice(0, 1) // 去除第一个元素：页面链接
		arrObj.map(obj => {
			obj.split('&').map(item => {
				const newItem = item.split('=')
				params[newItem[0]] = newItem[1].indexOf('#') ? newItem[1].split('#')[0] : newItem[1]
			})
		})
	}
	return params
}

/**
 * 判断浏览器/系统环境
 * @returns {Boolean}
 */
export function getBrowser() {
	const ua = window.navigator.userAgent || '';
	const isWeChat = /MicroMessenger/i.test(ua);
	const isWxWork = /MicroMessenger/i.test(ua) && /wxwork/i.test(ua); // 企业微信
	const isAndroid = /android/i.test(ua);
	const isIos = /iphone|ipad|ipod/i.test(ua);
	const isApp = /.*TcTravel.*/i.test(ua) || / ew(\w+)\/([\d.-_]*)/.test(ua);
	const isMiniProgram = function () {
		return new Promise((resolve, reject) => {
			// 先判断是否在微信浏览器环境
			if (navigator.userAgent.toLowerCase().indexOf("micromessenger") == -1) {
				resolve(false)
			} else {
				try {
					wx.miniProgram.getEnv((res) => { // 只有小程序环境有
						if (!res.miniprogram) {
							resolve(false)
						} else {
							resolve(true)
						}
					})
				} catch (err) {
					resolve(false)
				}
			}
		})
	}
	return {
		isWeChat,
		isWxWork,
		isMiniProgram,
		isAndroid,
		isIos,
		isApp
	}
}

/**
 * 获取网络链接中的文件名
 * @param url 网络链接
 * @param withExt 是否带后缀名
 */
export function getFileName(url: string, withExt = true) {
	const pos1 = url.lastIndexOf('\/') + 1
	const pos2 = url.lastIndexOf('.')
	const pos3 = url.indexOf('?')
	const fileName = withExt ? pos3 > 0 ? url.substring(pos1, pos3) : url.substring(pos1) : url.substring(pos1, pos2)
	return decodeURIComponent(fileName)
}

/**
 * 获取文件后缀名
 */
export function getFileExtension(filename: string) {
	if (!filename || typeof filename != 'string') {
		return ''
	}
	filename = getFileName(filename)
	const a = filename.split('').reverse().join('')
	const b = a.substring(0, a.search(/\./)).split('').reverse().join('')
	return b.toLowerCase()
}

/**
 * 获取文件类型
 */
export function getFileType(filename: string) {
	const fileExtension = getFileExtension(filename)
	const typeMap = {
		'音频': ['acc', 'amr', 'apc', 'ape', 'mp3', 'wav', 'flac'],
		'文章': ['txt', 'doc', 'docx', 'wps', 'pages'],
		'视频': ['wav', 'mp4', '3gp', 'asf', 'avi', 'f4v', 'flv', 'mjpeg', 'mov', 'm4v', 'mpeg'],
		'图片': ['bmp', 'jpg', 'png', 'tif', 'gif', 'svg', 'psd', 'cdr', 'pcd', 'ai', 'raw', 'webp'],
	}
	let type = ''
	for (const key in typeMap) {
		const val = typeMap[key]
		if (val.includes(fileExtension)) {
			type = key
			return type
		}
	}
	return type
}

/**
 * 阻止冒泡
 */
export function stopPropagation(e) {
	e.stopPropagation()
	e.nativeEvent.stopImmediatePropagation()
}

/**
 * 以逗号分隔的字符串操作
 */
export const StringOperate = {
	add: (str: string, target: string) => {
		return (/^\s*$/.test(str) ? '' : str + ',') + target
	},
	remove: (str: string, target: string) => {
		const pattern = new RegExp(target + '(,)?', 'g')
		return str.replace(pattern, '').replace(/,?$/, '')
	},
}

export function isArray(value: unknown) {
	return Object.prototype.toString.call(value) === '[object Array]'
}
export function isFunction(value: unknown) {
	return Object.prototype.toString.call(value) === '[object Function]'
}
export function isObject(value: unknown) {
	return Object.prototype.toString.call(value) === '[object Object]'
}
export function isString(value: unknown) {
	return Object.prototype.toString.call(value) === '[object String]'
}
export function isNumber(value: unknown) {
	return Object.prototype.toString.call(value) === '[object Number]'
}
export function compareSort(porperty) {
	return function(a,b) {
		const val1 = a[porperty]
		const val2 = b[porperty]
		return Number(val1) - Number(val2)
	}
}
// 计算改变后的字幕位置及宽度 压缩字幕
export function getNewInfo(moveItem, info, timelineScaleWidth) {
	info.sort(compareSort('startTime'))
	const newInfo = []
	newInfo.push(moveItem)
	if(info.length > 1) {
		info.map(item => {
			if(item.endTime <= moveItem.startTime || item.startTime >= moveItem.endTime) {
				// 不受当前移动影响的item
				newInfo.push(item)
			} else if(item.endTime > moveItem.startTime && item.startTime < moveItem.startTime && item.endTime < moveItem.endTime) {
				// 压缩前面的一条
				item.endTime= moveItem.startTime
				item.width = Number(((parseFloat(item.endTime) - parseFloat(item.startTime)) * timelineScaleWidth).toFixed(0))
				newInfo.push(item)
			} else if(
				(item.startTime < moveItem.endTime && item.endTime > moveItem.endTime && item.startTime > moveItem.startTime)||
				(item.startTime < moveItem.startTime && item.endTime > moveItem.endTime)
			) {
				// 压缩后面一条
				item.startTime = moveItem.endTime
				item.trackX = parseFloat(item.startTime) * timelineScaleWidth
				item.width = Number(((parseFloat(item.endTime) - parseFloat(item.startTime)) * timelineScaleWidth).toFixed(0))
				newInfo.push(item)
			}
		})
		newInfo.sort(compareSort('startTime'))
	}
	return newInfo
}
// 不压缩
export function getNewInfo2(moveIndex, info, timelineScaleWidth) {
	const newInfo = JSON.parse(JSON.stringify(info))
	// newInfo.sort(compareSort('startTime'))
	const preItem = newInfo[moveIndex-1]
	const currentItem = newInfo[moveIndex]
	const nextItem = newInfo[moveIndex+1]
	if(preItem && preItem.endTime > currentItem.startTime) {
		currentItem.startTime = preItem.endTime
		currentItem.trackX = parseFloat(currentItem.startTime) * timelineScaleWidth
		currentItem.width = Number(((parseFloat(currentItem.endTime) - parseFloat(currentItem.startTime)) * timelineScaleWidth).toFixed(0))
	}
	if(nextItem && nextItem.startTime < currentItem.endTime) {
		currentItem.endTime = nextItem.startTime
		currentItem.trackX = parseFloat(currentItem.startTime) * timelineScaleWidth
		currentItem.width = Number(((parseFloat(currentItem.endTime) - parseFloat(currentItem.startTime)) * timelineScaleWidth).toFixed(0))
	}
	return newInfo
}
export function uuid(format) {
	let d = new Date().getTime()

	return (format || 'xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx').replace(/[xy]/g, function (c) {
		let r = (d + Math.random() * 16) % 16 | 0
		d = Math.floor(d / 16)
		return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
	})
}
/**
 * 删除对象中为空的字段（包括空数组、空对象）
 */
export const removeEmptyField = (fieldsValue: object) => {
	const target = Object.assign({}, fieldsValue)
	Object.keys(target).map(key => {
		const value = target[key]
		const shouldDelete = !value
			|| (Object.prototype.toString.call(value) === '[object Array]' && !value.length)
			|| (Object.prototype.toString.call(value) === '[object Object]' && !Object.keys(value).length)
		if (shouldDelete) delete target[key] // 如果为空则删除该字段
	})
	return target
}
export const formatTime = (val, millisecond) => {
	// example 将2.350秒转为 00:00:02,350
	const time = Number(val)
	const integer= parseInt(time)
	const timeArr = time.toString().split('.')
	const decimals = timeArr.length > 1 ? Number((time.toString().split('.'))[1])*1000 : '000'
	const decimalsFormat =time > 0 ? decimals.length === 3 ? decimals : (decimals.toString()).slice(0,3) : '000'
	let minute = 0
	let hours = 0
	let second = integer
	if(time >= 60) {
		second = integer%60
		minute = parseInt(integer/60)
	}
	if(minute >=60) {
		hours = parseInt(minute/60)
		minute = minute%60
	}
	return `${hours > 9 ? hours : `0${hours}`}:${minute > 9 ? minute : `0${minute}`}:${second > 9 ? second : `0${second}`}${millisecond ?`,${decimalsFormat}` : ''}`
}
export interface WatermarkOptionsType {
	id?: string;
	target?: Element;
	txt?: string;
	xPoint?: number;
	yPoint?: number;
	rows?: number;
	cols?: number;
	xSpace?: number;
	ySpace?: number;
	width?: number;
	height?: number;
	angle?: number;
}
/**
 * 生成网页水印
 */
export class Watermark {
	_options: WatermarkOptionsType
	_styleOptions: Partial<CSSStyleDeclaration>

	constructor(options?: WatermarkOptionsType, customStyle?: Partial<CSSStyleDeclaration>) {
		const defaultOptions: WatermarkOptionsType = { // 默认设置
			id: 'watermark',
			target: document.body,
			txt: 'text',
			xPoint: 20, // 水印起始位置x轴坐标
			yPoint: 20, // 水印起始位置Y轴坐标
			rows: 20, // 水印行数
			cols: 20, // 水印列数
			xSpace: 100, // 水印x轴间隔
			ySpace: 50, // 水印y轴间隔
			width: 210, // 水印宽度
			height: 80, // 水印长度
			angle: 30, // 倾斜角度
		}
		const defaultStyle: Partial<CSSStyleDeclaration> = { // 默认样式
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			opacity: '0.1',
			fontSize: '14px',
			textAlign: 'center',
			overflow: 'hidden',
			whiteSpace: 'pre', // 识别换行符
		}
		this._options = Object.assign(defaultOptions, options)
		this._styleOptions = Object.assign(defaultStyle, customStyle)
	}

	append = () => {
		let {
			id,
			target,
			txt,
			xPoint,
			yPoint,
			rows,
			cols,
			xSpace,
			ySpace,
			width,
			height,
			angle,
		} = this._options

		// 防止重复添加水印
		if (document.getElementById(id)) return

		// const oTemp = document.createDocumentFragment()
		const oTemp = document.createElement('div')
		oTemp.id = id
		// 这种写法是水印固定 不跟随页面滚动
		oTemp.style.cssText = `
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			overflow: hidden;
			pointer-events: none;
		`
		// const pWidth = Math.max(document.body.scrollWidth, document.body.clientWidth) // 获取页面最大宽度
		// const pageHeight = Math.max(document.body.scrollHeight, document.body.clientHeight) + 450 // 获取页面最大高度
		const pWidth = window.screen.availWidth || Math.max(document.body.scrollWidth, document.body.clientWidth)
		const cutWidth = pWidth * 0.0150
		const pageWidth = pWidth - cutWidth
		const pageHeight = window.screen.availHeight || Math.max(document.body.scrollHeight, document.body.clientHeight)
		// 如果将水印列数设置为0，或水印列数设置过大，超过页面最大宽度，则重新计算水印列数和水印x轴间隔
		if (cols === 0 || (parseInt(xPoint + width * cols + xSpace * (cols - 1) + '') > pageWidth)) {
			cols = parseInt((pageWidth - xPoint + xSpace) / (width + xSpace) + '')
			xSpace = parseInt((pageWidth - xPoint - width * cols) / (cols - 1) + '')
		}
		// 如果将水印行数设置为0，或水印行数设置过大，超过页面最大长度，则重新计算水印行数和水印y轴间隔
		if (rows === 0 || (parseInt(yPoint + height * rows + ySpace * (rows - 1) + '') > pageHeight)) {
			rows = parseInt((ySpace + pageHeight - yPoint) / (height + ySpace) + '')
			ySpace = parseInt(((pageHeight - yPoint) - height * rows) / (rows - 1) + '')
		}
		let x
		let y
		for (let i = 0; i < rows; i++) {
			y = yPoint + (ySpace + height) * i
			for (let j = 0; j < cols; j++) {
				x = xPoint + (width + xSpace) * j
				const maskDiv = document.createElement('div')
				maskDiv.id = 'mask_div' + i + j
				maskDiv.className = 'mask_div'
				maskDiv.appendChild(document.createTextNode(txt))
				// 设置水印div倾斜显示

				const baseStyle: Partial<CSSStyleDeclaration> = { // 不可以被覆盖的样式
					display: 'block',
					transform: 'rotate(-' + angle + 'deg)',
					visibility: '',
					position: 'absolute',
					left: x + 'px',
					top: y + 'px',
					width: width + 'px',
					height: height + 'px',
					pointerEvents: 'none', // pointer-events:none 让水印不遮挡页面的点击事件
				}

				const styleOptions = {
					...this._styleOptions,
					...baseStyle,
				}

				for (const key in styleOptions) {
					maskDiv.style[key] = styleOptions[key]
				}
				oTemp.appendChild(maskDiv)
			}
		}
		target.appendChild(oTemp)
	}

	remove = () => {
		const { id, target } = this._options
		if (!document.getElementById(id)) return
		target.removeChild(document.getElementById(id))
	}
}

/**
 * 生成指定区间指定间隔的数组
 */
export function generateArray(min: number, max: number, step: number) {
	const len = Math.abs(max - min)
	if (len <= 0) return []
	const arr = new Array(len)
	let cNum = min
	let cIndex = 0
	function addArr(index, val) {
		if (cNum >= min && cNum <= max) {
			arr[index] = cNum
			cNum++
			cIndex++
			addArr(cIndex, cNum)
		}
	}
	addArr(cIndex, cNum)
	return arr.filter(item => item % step == 0)
}

/**
 * Html文本转义
 */
export function HTMLEncode(html) {
	let temp = document.createElement('div')
	temp.textContent != null ? (temp.textContent = html) : (temp.innerText = html)
	const output = temp.innerHTML
	temp = null
	return output
}

/**
 * Html文本反转义
 */
export function HTMLDecode(text) {
	let temp = document.createElement('div')
	temp.innerHTML = text
	const output = temp.innerText || temp.textContent
	temp = null
	return output
}
/**
 * 获取文字所占宽度
 */
export function getTextWidth(text, font) {
	const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement('canvas'))
	const context = canvas.getContext('2d')
	context.font = font
	const metrics = context.measureText(text)
	return metrics.width
}
/**
 * 获取文字字节数
 */
function strLen(str) {
	let len = 0
	for(let i = 0; i < str.length; i++) {
		if(str.charCodeAt(i) > 255 || str.charCodeAt(i) < 0) len +=2; else len ++
	}
	return len
}
/**
 * 获取文字固定宽度插入\n
 */
export function textWrap(str, fixWidth, fontstyle) {
	let len = 0
	let text = ''
	let remainder = 0
	const soloTextWidth = getTextWidth(str, fontstyle)/strLen(str)
	const widthOfStrNumber = Math.ceil(fixWidth/soloTextWidth)
	for(let i = 0; i < str.length; i++) {
		if(str.charCodeAt(i) > 255 || str.charCodeAt(i) < 0) {
			len +=2
		} else {
			len ++
		}
		if(len%widthOfStrNumber < remainder) {
			text=	text + '\\n' + str[i]
		} else {
			text=text + str[i]
		}
		remainder = len%widthOfStrNumber
	}
	return text
}

export function dateFormat(fmt, date) {
	let ret
	const opt = {
		'Y+': date.getFullYear().toString(),        // 年
		'm+': (date.getMonth() + 1).toString(),     // 月
		'd+': date.getDate().toString(),            // 日
		'H+': date.getHours().toString(),           // 时
		'M+': date.getMinutes().toString(),         // 分
		'S+': date.getSeconds().toString()          // 秒
	}
	for (let k in opt) {
		ret = new RegExp('(' + k + ')').exec(fmt)
		if (ret) {
			fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
		}
	}
	return fmt
}

/**
 * 验证对象 有属性为空则不通过
 * @param obj
 */
export function objValidate(obj) {
	for(const key in obj){
		if(!obj[key]) return false
	}
	return true
}

/**
 * 获取字符串字节长度
 * @param str
 */
export function getByteLength(a: string) {
	let b = 0
	for (let i = a.length; i-- > 0;) {
		if (a[i].charCodeAt() > 255) {
			b += 2
		} else {
			b++
		}
	}
	return b
}
/// 绘制文本
export const drawText = function (options) {
	/// 获取总行数
	const allRow = Math.ceil(options.ctx.measureText(options.str).width / options.maxWidth)
	/// 限制行数
	const count = allRow >= options.maxLine ? options.maxLine : allRow
	/// 当前字符串的截断点
	let endPos = 0

	/// 循环截断
	for (let j = 0; j < count; j++) {
		/// 当前剩余的字符串
		const nowStr = options.str.slice(endPos),
			/// 每一行顶部距离
			y = options.y + (count == 1 ? 0 : j * (options.height + 5))
			/// 每一行当前宽度
		let rowWid = 0
		/// 如果当前的字符串宽度大于最大宽度，然后开始截取
		if (options.ctx.measureText(nowStr).width > options.maxWidth) {
			for (let m = 0; m < nowStr.length; m++) {
				/// 计算当前字符串总宽度
				rowWid += options.ctx.measureText(nowStr[m]).width
				if (rowWid > options.maxWidth) {
					/// 如果是最后一行
					if (j === options.maxLine - 1) {
						options.ctx.fillText(nowStr.slice(0, m - 1) + '...', options.x, y)
					} else {
						options.ctx.fillText(nowStr.slice(0, m), options.x, y)
					}
					/// 保留下次截断点
					endPos += m
					break
				}
			}
		} else { /// 如果当前的字符串宽度小于最大宽度就直接输出
			options.ctx.fillText(nowStr.slice(0), options.x, y)
		}
	}
}